import { render, staticRenderFns } from "./WorkerInfo.vue?vue&type=template&id=712534d5&"
import script from "./WorkerInfo.vue?vue&type=script&lang=js&"
export * from "./WorkerInfo.vue?vue&type=script&lang=js&"
import style0 from "./WorkerInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports